import { render, staticRenderFns } from "./ERegistrationOwnerUpgradeView.vue?vue&type=template&id=29213eea&scoped=true&"
import script from "./ERegistrationOwnerUpgradeView.vue?vue&type=script&lang=js&"
export * from "./ERegistrationOwnerUpgradeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29213eea",
  null
  
)

export default component.exports